import React, { PureComponent } from 'react';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
import { formatImage } from '@ifeng-fe/container_channel/common/client/winter/utils/formatImg';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const RightOne = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
            show: PropTypes.bool,
        };
        render() {
            const { content } = this.props;
            const config = {
                arrows: true,
                dots: false,
                dotsAction: 'click',
                autoplay: true,
                autoplayInterval: 6000,
                speed: 1000,
                dotStyle: styles.dot,
                dotCurrentStyle: styles.current,
                unitSize: 778,
            };
            let contnetList = [];

            if (content && content.map) {
                contnetList = content.map(item => ({
                    src: item && item.src ? formatImage(item.src, 778, 450) : '',
                }));
            }

            return (
                <div className={styles.tab_box} id="box_01" style={{ marginTop: '23px' }}>
                    <div className={`${styles.ggjs} ${styles.ggjs_w778}`} />
                    <div className={styles.box_b} style={{ display: this.props.show ? 'block' : 'none' }}>
                        <ul className={styles.list1_b}>
                            <Slides config={config} content={content} />
                        </ul>
                    </div>
                </div>
            );
        }
    },
);

export { RightOne };
export default RightOne;
